import * as Yup from 'yup';
export class EmpresasSchema {
  public static id() {
    return Yup.number().positive('ID deve ser um maior que zero');
  }
  public static record() {
    return Yup.object().shape(recordShape);
  }
}

const recordShape = {
  fantasyName: Yup.string(),
  legalName: Yup.string(),
  document: Yup.string(),
  enabled: Yup.bool()
};
